import { translate } from "app/filters/i18nFilter";
import { getIsKeywordsLocked } from "app/pages/activation/helpers/getIsLockedComponent";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ModalFlow } from "../../components/Topics/Modal/types";
import { MENU_ITEMS, TopicMenu } from "../../components/Topics/Topic/Menu/constants";
import { useTopicsContext } from "../../context/Topics/TopicsContext";
import { useTopicsDataContext } from "../../context/Topics/TopicsDataContext";
import { useTopicsModalContext } from "../../context/Topics/TopicsModalContext";
import { activationTracking } from "../../services/tracking";

export const useTopicItem = ({
    topicId,
    isPreloading,
    isShared,
    keywordsCount,
}: {
    topicId: string;
    isPreloading: boolean;
    isShared: boolean;
    keywordsCount: number | string;
}) => {
    const { granularity, country, activationId, onDownloadExcel, downloadingTopics } = useTopicsContext();
    const { isLoading: isDataLoading, isDisabled, isSuggestion } = useTopicsDataContext();

    const { onEditMenuClick, onDeleteMenuClick } = useTopicsModalContext();

    const track = activationTracking.home;
    const isLoading = isDataLoading || isPreloading;
    const isKeywordsLocked = getIsKeywordsLocked();

    const onClick = () => {
        if (!isLoading && !isDisabled) {
            const url = proNavigator.href(
                "digitalsuite_monitorkeywords",
                {
                    keywordGroupId: topicId,
                    country,
                    duration: "12m",
                    webSource: devicesTypes.DESKTOP,
                    activationSetId: activationId,
                    keyword: `*${topicId}`,
                },
                { absolute: true },
            );
            window.open(url);

            track.trackTopicClick();
        }
    };

    const onMenuClick = ({ id }: { id: TopicMenu }) => {
        const menuItem = MENU_ITEMS.find((item) => id === item.id);
        const modalFlow = isShared ? ModalFlow.DeleteShared : ModalFlow.Delete;

        if (!menuItem) {
            return;
        }

        const textForTracking = menuItem.title;
        track.trackTopicContextMenu(translate(textForTracking));

        const menuActions = {
            [TopicMenu.DownloadExcel]: onDownloadExcel.bind(null, topicId, keywordsCount),
            [TopicMenu.Delete]: onDeleteMenuClick.bind(null, topicId, isShared, modalFlow),
            [TopicMenu.Edit]: onEditMenuClick.bind(null, topicId),
        };

        menuActions[id]?.();
    };

    return {
        isLoading,
        isDisabled,
        isSuggestion,
        onClick,
        onMenuClick,
        onDownloadExcel,
        granularity,
        topicId,
        downloadingTopics,
        isKeywordsLocked,
    };
};
